import { Show } from "solid-js";
import { Form } from "solid-bootstrap";
import { toPixelNum, toPointNum } from "../../util/size/size";
import { ColorField } from "../colorfield/colorfield";

export function FormWidget(props) {
    if (!props.name) {
        throw new Error('ThemeFormWidget requires a name prop');
    }
    const controlId = `theme.${props.name}`;
    props.controlId = controlId;
    function isNumberInput() {
        return props.kind === 'number';
    }
    function isSelectInput() {
        return props.kind === 'select';
    }
    function isColorInput() {
        return props.kind === 'color';
    }
    function isPixelInput() {
        return props.kind === 'pixel';
    }
    function isPointInput() {
        return props.kind === 'point';
    }
    return <>
        <Show when={isPixelInput()}>
            <PixelInput {...props} />
        </Show>
        <Show when={isPointInput()}>
            <PointInput {...props} />
        </Show>
        <Show when={isNumberInput()}>
            <NumberInput {...props} />
        </Show>
        <Show when={isSelectInput()}>
            <SelectInput {...props} />
        </Show>
        <Show when={isColorInput()}>
            <ColorInput {...props} />
        </Show>
    </>
}

function PixelInput(props) {
    function hasValue(theme) {
        return theme() && theme()[props.name];
    }
    function getValue(theme) {
        if (!hasValue(theme)) {
            return 1;
        }
        return toPixelNum(theme()[props.name]);
    }
    return <Form.Group controlId={props.controlId}>
        <Form.Label>{props.label}</Form.Label>
        <Form.Control type="number" value={getValue(props.themeSignal)} pattern={numConstraint} required />
    </Form.Group>
}

function PointInput(props) {
    function hasValue(theme) {
        return theme() && theme()[props.name];
    }
    function getValue(theme) {
        if (!hasValue(theme)) {
            return 1;
        }
        return toPointNum(theme()[props.name]);
    }
    return <Form.Group controlId={props.controlId}>
        <Form.Label>{props.label}</Form.Label>
        <Form.Control type="number" value={getValue(props.themeSignal)} pattern={numConstraint} required />
    </Form.Group>
}

function NumberInput(props) {
    function hasValue(theme) {
        return theme() && theme()[props.name];
    }
    function getValue(theme) {
        if (!hasValue(theme)) {
            return 1;
        }
        return theme()[props.name];
    }
    return <Form.Group controlId={props.controlId}>
        <Form.Label>{props.label}</Form.Label>
        <Form.Control type="number" value={getValue(props.themeSignal)} pattern={numConstraint} required />
    </Form.Group>
}

function SelectInput(props) {
    function getValue(theme) {
        if (!theme() || !theme()[props.name]) {
            return props.options[0].value; // Default to first option
        }
        return theme()[props.name];
    }
    return <Form.Group controlId={props.controlId}>
        <Form.Label>{props.label}</Form.Label>
        <Form.Select>
            {props.options.map((option, index) =>
                <>
                    <Show when={option["value"] === getValue(props.themeSignal)}>
                        <option selected key={index} value={option["value"]}>{option["label"]}</option>
                    </Show>
                    <Show when={option["value"] !== getValue(props.themeSignal)}>
                        <option key={index} value={option["value"]}>{option["label"]}</option>
                    </Show>
                </>
            )}
        </Form.Select>
    </Form.Group>
}

function ColorInput(props) {
    return <ColorField controlId={props.controlId} label={props.label} themeSignal={props.themeSignal} valueFunc={(theme) => theme[props.name]} />
}

const numConstraint = "^[1-9][0-9]*$";